/**
 * Supabase client — the single connection the whole app shares.
 *
 * The publishable key below is embedded in the production bundle and is meant
 * to be. It grants nothing on its own: every table has Row Level Security
 * enabled, `anon` is revoked from all tables, and the only things an
 * unauthenticated visitor can reach are the five SECURITY DEFINER functions
 * that back the public share links (see supabase/schema.sql).
 *
 * The SECRET key must never appear in this file or anywhere under src/.
 * It lives in the repo-root .env and is used only by scripts/migrate-to-supabase.js.
 */

import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL =
  process.env.REACT_APP_SUPABASE_URL || "https://znwbcoivnvyzcsqpfuju.supabase.co";

const SUPABASE_PUBLISHABLE_KEY =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  "sb_publishable_51hcZ4j_IodbadwNo9KCTg__jTtMP4s";

if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  // Surfaces immediately in the console rather than as a stream of null
  // responses from every route.
  console.error(
    "[supabase] Missing configuration. Set REACT_APP_SUPABASE_URL and " +
    "REACT_APP_SUPABASE_ANON_KEY in Razergrid/.env, then restart the dev server."
  );
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // The app is served from a single page with hash-based share links
    // (#day=...). Leaving this on would make supabase-js try to parse those
    // hashes as auth callbacks.
    detectSessionInUrl: false,
    storageKey: "razergrid-supabase-auth",
  },
});
